import React from "react";
import imgtenant from "../../assets/tenant/tenant.js";
import "./tenant.scss";

const tenant = () => {
  return (
    <div className="tenant">
      <div className="container-tenant">
        <div className="header-tenant">A Community of Thriving Tenants</div>
        <div className="content-tenant">
          <div className="tenanta">
            {imgtenant.map((logo, index) => (
              <div className="logotenant">
                <img key={index} src={logo} alt="logo-tenant" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default tenant;
